import React, { FunctionComponent } from 'react';
import Pagination from '../components/Pagination';
import Spinner from '../components/Spinner';
import { useLibraryContext } from '../contexts/LibraryContext';
import LibraryControlContainer from '../components/LibraryControlContainer';
import AssetGallery from '../components/AssetGallery';
import UploadAsset from './UploadAsset';
import useMarket from '../hooks/useMarket';
import useHash from '../hooks/useHash';
import ApprovalStatusChart from '../components/ApprovalStatusChart';
import { useAnalyticsContext } from '../contexts/AnalyticsContext';
import UserUploadChart from '../components/UserUploadChart';
import ReviewTimeLine from '../components/ReviewTimeLine';
import RuleOutcomeChart from '../components/RuleOutcomeChart';

const Analytics: FunctionComponent = () => {
    const {
        state: { analyticsData, isLoading },
    } = useAnalyticsContext();

    const market = useMarket();
    const { hash } = useHash();

    return (
        <div className="wrapper-container">
            <div className="filter-controls">
                <h2>Analytics</h2>
            </div>
            {isLoading || !analyticsData ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                    }}
                >
                    <Spinner title="Loading..." />
                </div>
            ) : (
                <div className="analytics-content">
                    <div className="analytics-row">
                        <div className="chart-box">
                            <h3>Approval Status</h3>
                            <ApprovalStatusChart
                                data={analyticsData.status_counts}
                            />
                        </div>
                        <div className="chart-box">
                            <h3>User Activity</h3>
                            <UserUploadChart data={analyticsData.user_counts} />
                        </div>
                    </div>
                    <div className="analytics-row">
                        <div className="chart-box">
                            <h3>Rule Outcomes</h3>
                            <RuleOutcomeChart
                                data={analyticsData.rule_oucome_counts}
                            />
                        </div>
                    </div>
                    <div className="analytics-row">
                        <div className="chart-box">
                            <h3>Review Activity</h3>
                            <ReviewTimeLine data={analyticsData.date_counts} />
                        </div>
                    </div>
                </div>
            )}

            {/* {libraryIsLoading && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh',
                        }}
                    >
                        <Spinner title="Loading..." />
                    </div>
                )}
                {!libraryIsLoading && (
                    <AssetGallery
                        imageUrls={imageUrls}
                        libraryAssets={libraryAssets}
                    />
                )}
                {libraryAssets.length > 0 && (
                    <Pagination
                        totalPages={totalPages}
                        isPrevPageAvailable={isPrevPageAvailable}
                        isNextPageAvailable={isNextPageAvailable}
                        currentPage={currentPage}
                    />
                )} */}
        </div>
    );
};

export default Analytics;
